import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/reorderRankForStoredFilterBulkAssignTags', params).then((response) => response.data);
};

export const useMutationReorderRankForStoredFilterBulkAssignTags = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    idList: { id: number; rank: number }[];
    contractId: number;
}
